<template>
  <div>
    <!-- search input -->
    <section id="knowledge-base-search">
      <b-card
        no-body
        class="knowledge-base-bg text-center"
        :style="{backgroundImage: `url(${require('@/assets/images/banner/banner.png')})`}"
      >
        <b-card-body class="card-body">
          <h2 class="text-primary">
            Fuente dedicada utilizada en el sitio web
          </h2>
          <b-card-text class="mb-2">
            <span>Búsquedas populares: </span>
            <span class="font-weight-bolder">Pre-Registro, confirmar cuenta por correo electrónico</span>
          </b-card-text>

          <!-- form -->
          <b-form class="kb-search-input">
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>
              <b-form-input
                id="searchbar"
                v-model="knowledgeBaseSearchQuery"
                placeholder="Hacer una pregunta...."
              />
            </b-input-group>
          </b-form>
          <!-- form -->
        </b-card-body>
      </b-card>
    </section>
    <!--/ search input -->

    <section id="knowledge-base-content">

      <!-- content -->
      <b-row class="kb-search-content-info match-height">
        <b-col
          v-for="item in filteredKB"
          :key="item.id"
          md="4"
          sm="6"
          class="kb-search-content"
        >
          <b-card
            class="text-center cursor-pointer"
            :img-src="item.img"
            :img-alt="item.img.slice(5)"
            img-top
            @click="$router.push({ name: 'pages-knowledge-base-category', params: { category: item.category } })"
          >
            <h4>{{ item.title }}</h4>
            <b-card-text class="mt-1">
              {{ item.desc }}
            </b-card-text>
          </b-card>
        </b-col>
        <b-col
          v-show="!filteredKB.length"
          cols="12"
          class="text-center"
        >
          <h4 class="mt-4">
            Resultado de búsqueda no encontrado!!
          </h4>
        </b-col>
      </b-row>
    </section>
  </div>
</template>

<script>
import {
  BRow, BCol, BCard, BCardBody, BForm, BInputGroup, BFormInput, BCardText, BInputGroupPrepend,
} from 'bootstrap-vue'
/* eslint-disable global-require */
export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BCardText,
    BForm,
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
  },
  data() {
    return {
      knowledgeBaseSearchQuery: '',
      kb: [
        {
          id: 1,
          category: 'sales-automation',
          img: require('@/assets/images/illustration/sales.svg'),
          title: 'Pagos por dependencias',
          desc: 'Obten descuentos por multiples inscritos.',
        },
        {
          id: 2,
          category: 'marketing-automation',
          img: require('@/assets/images/illustration/marketing.svg'),
          title: 'Maestros 24/7',
          desc: 'Mira las opciones que tenemos de profesionales en cada cuatrimestre.',
        },
        {
          id: 3,
          category: 'api-questions',
          img: require('@/assets/images/illustration/api.svg'),
          title: 'Salon de Clases',
          desc: 'como subir actividades y ver calificaciones',
        },
        {
          id: 4,
          category: 'personalization',
          img: require('@/assets/images/illustration/personalization.svg'),
          title: 'Materiales Disponibles',
          desc: 'It has been said that astronomy is a humbling and character experience.',
        },
        {
          id: 5,
          category: 'email-marketing',
          img: require('@/assets/images/illustration/email.svg'),
          title: 'Mensajeria',
          desc: 'There is perhaps no better demonstration of the folly of human conceits.',
        },
        {
          id: 6,
          category: 'demand-generation',
          img: require('@/assets/images/illustration/demand.svg'),
          title: 'Inscripciones',
          desc: 'Competent means we will never take anything for granted.',
        },
      ],
    }
  },
  computed: {
    filteredKB() {
      const knowledgeBaseSearchQueryLower = this.knowledgeBaseSearchQuery.toLowerCase()
      return this.kb.filter(item => item.title.toLowerCase().includes(knowledgeBaseSearchQueryLower) || item.desc.toLowerCase().includes(knowledgeBaseSearchQueryLower))
    },
  },
  created() {
    // this.$http.get('/kb/data/knowledge_base').then(res => { this.kb = res.data })
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-knowledge-base.scss';
</style>
